import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HelpBodyEmailMarketing() {
    return (
        <OnboardingBody title='What is email automation?'>
            <div>
                <p>
                    Connect sales automation to your email marketing tool to support your sales team
                    at each stage. You may want to craft a series of email messages that are
                    relevant at different points in the buyer’s journey.
                </p>
            </div>
        </OnboardingBody>
    );
}
